import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import Global from '../../../../../store/global-selectors';
import { FormattedWeight } from '../../../../../components/formatted-weight';
import { ltlShipmentsGridMessages } from '../messages';

const Weight = ({ freightShipmentId }: { freightShipmentId: string }) => {
  const shipment = useSelector((state) => Global.selectEntitiesFreightShipmentById(state, { freightShipmentId }));

  if (shipment?.totalWeight == null) {
    return '';
  }

  const weightUnit = shipment.handlingUnits?.[0]?.commodities?.[0]?.weightUnit || 'Pounds';
  return <FormattedWeight weight={{ value: shipment.totalWeight, unit: weightUnit }} />;
};

export const weight = {
  getMessageDescriptor: () => ltlShipmentsGridMessages.weight,
  name: <FormattedMessage {...ltlShipmentsGridMessages.weight} />,
  id: 'weight',
  width: 85,
  minWidth: 70,
  index: 6,
  render: (data: { id: string }) => <Weight freightShipmentId={data.id} />,
};
